import { Grid } from '@mui/material';
import { SignUpForm } from 'components/Forms';
import { DashboardTitle } from 'components/Titles';

export const VetProfile = () => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <DashboardTitle title="CONFIGURAÇÕES DO PERFIL" />
      </Grid>
      <Grid item xs={12}>
        <SignUpForm />
      </Grid>
    </Grid>
  );
};
